import { Injectable } from '@angular/core';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { assets } from '../core/constants/assets.const';
import { BehaviorSubject } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment.development';
@Injectable({
  providedIn: 'root'
})
export class MessagingService {

  assetsConst = assets;
  private receivedMessageIds = new Set<string>();
  private messageSource = new BehaviorSubject<any>(null);
  public currentMessage = this.messageSource.asObservable();
  constructor(private translate: TranslateService) {}


  requestPermission(): void {
    const messaging = getMessaging();
    navigator.serviceWorker.ready
      .then((registration) => {
        return getToken(messaging, {
          vapidKey: environment.firebaseConfig.vapidKey,
          serviceWorkerRegistration: registration
        });
      })
      .then((currentToken) => {
        if (currentToken) {  
          localStorage.setItem('fcmToken', currentToken);      
        } else {
          alert(this.translate.instant('common.fcmNotification'));
        }
      })
      .catch(() => {
        // console.log('An error occurred while retrieving token. ', err);
      });
  }

  listenForFrontMessages(): void {
    const messaging = getMessaging();
    onMessage(messaging, (payload) => {
      const message = payload;
      const messageId = payload.messageId;
  
      if (!messageId) {
        return;
      }
  
      if (this.receivedMessageIds.has(messageId)) {
        return; // Skip duplicate notification
      }
  
      this.receivedMessageIds.add(messageId);

      if (message.notification) {
        this.playNotificationSound();
        const notificationOptions = {
          body: message.notification['body'] || 'Click to view',
          icon: this.assetsConst.ntfy_logo,
          data: payload
        };
          // Display notification using service worker
        this.displayNotification(message.notification['title'] || 'New Notification', notificationOptions);
      }
    });
    
  }

  private displayNotification(title: string, options: NotificationOptions): void {
    const currentLang = this.translate.currentLang || 'en'; // Default to English
    const isRtl = this.isRtlLanguage(currentLang);
    options = {
      ...options,
      dir: isRtl ? 'rtl' : 'ltr' // ✅ Set text direction dynamically
    };
    navigator.serviceWorker.getRegistration('/firebase-cloud-messaging-push-scope')
      .then((registration) => {
        if (registration) {
          registration.showNotification(title, options);
        } else {
          console.error('Service worker registration not found.');
        }
      });
  }

  private playNotificationSound(): void {
    const audio = new Audio(this.assetsConst.notificationSound); // Adjust path as needed
    audio.play().catch((error) => {
      console.error('Error playing notification sound:', error);
    });
  }

  private isRtlLanguage(lang: string): boolean {
    const rtlLanguages = ['ar']; // Add other RTL languages if needed
    return rtlLanguages.includes(lang);
  }
}
